import React, {Component} from 'react';
import {Row} from "reactstrap";

import {weeks} from "../../../services/date/date-service";

import './past-days-of-activity.css'

class PastDaysOfActivity extends Component {
    padStr(i) {
      return (i < 10) ? "0" + i : "" + i;
    }

    formatDate(date) {
        var year = date.getFullYear();
        var month = this.padStr(date.getMonth() + 1);
        var day = this.padStr(date.getDate());
        return year + "-" + month + "-" + day;
    }

    render() {
        const {numberOfWeeks, activityDict} = this.props;
        const calendar = weeks(numberOfWeeks);

        const activityNone = {color: "#eee", count: 0};
        const activityLow = {color: "#c6e48b", count: 1};
        const activityMedium = {color: "#7bc96f", count: 3};
        const activityHigh = {color: "#239a3b", count: 5};
        const activityActive = {color: "#196127", count: 8};
        const activityHeatMap = [activityNone, activityLow, activityMedium, activityHigh, activityActive];

        return (
            <div>
                <Row>
                    <table className="text-center Past-Days-Of-Activity-tableStyle">
                        <tbody>
                        {calendar.map((week) =>
                            <tr key={week}>
                                {week.map((date) => {

                                        let formattedDate = this.formatDate(date);
                                        const activityCount = activityDict[formattedDate] ? activityDict[formattedDate] : 0;

                                        const dateColor = activityHeatMap.filter(activity => activityCount >= activity.count).pop().color;

                                        return <td key={date}
                                                   title={activityCount}
                                                   className="py-1 Past-Days-Of-Activity-cell"
                                                   style={{backgroundColor: dateColor}}>
                                            <div className="my-auto text-secondary Past-Days-Of-Activity-date">
                                                {`${date.getMonth() + 1}/${date.getDate()}`}</div>
                                        </td>
                                    }
                                )}
                            </tr>
                        )}
                        </tbody>
                    </table>
                </Row>
                <Row>
                    <div className="mr-1 small">Less</div>
                    {activityHeatMap.map(
                        activityKey => <span key={activityKey.color}
                                             className="mt-1 mr-1 Past-Days-Of-Activity-legendItem"
                                             title={`Activity count less than or equal to ${activityKey.count}`}
                                             style={{backgroundColor: activityKey.color}}/>
                    )}
                    <div className="mr-1 small">More</div>
                </Row>
            </div>
        )
    }
}

export default PastDaysOfActivity;



// WEBPACK FOOTER //
// ./src/components/components/past-days-activity/past-days-of-activity.js